import { SVGProps } from 'react'

export const GalleryPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.41667 2.50008H5.5C4.09987 2.50008 3.3998 2.50008 2.86502 2.77257C2.39462 3.01225 2.01217 3.3947 1.77248 3.86511C1.5 4.39988 1.5 5.09995 1.5 6.50008V13.5001C1.5 14.9002 1.5 15.6003 1.77248 16.1351C2.01217 16.6055 2.39462 16.9879 2.86502 17.2276C3.3998 17.5001 4.09987 17.5001 5.5 17.5001H13.1667C13.9416 17.5001 14.3291 17.5001 14.647 17.4149C15.5098 17.1837 16.1836 16.5099 16.4148 15.6471C16.5 15.3292 16.5 14.9417 16.5 14.1667M14.8333 6.66675V1.66675M12.3333 4.16675H17.3333M7.75 7.08341C7.75 8.00389 7.00381 8.75008 6.08333 8.75008C5.16286 8.75008 4.41667 8.00389 4.41667 7.08341C4.41667 6.16294 5.16286 5.41675 6.08333 5.41675C7.00381 5.41675 7.75 6.16294 7.75 7.08341ZM11.4917 9.93187L4.44262 16.3401C4.04614 16.7006 3.84789 16.8808 3.83036 17.0369C3.81516 17.1722 3.86704 17.3064 3.96932 17.3964C4.08732 17.5001 4.35523 17.5001 4.89107 17.5001H12.7133C13.9126 17.5001 14.5123 17.5001 14.9833 17.2986C15.5745 17.0457 16.0456 16.5746 16.2985 15.9833C16.5 15.5124 16.5 14.9127 16.5 13.7134C16.5 13.3099 16.5 13.1081 16.4559 12.9202C16.4005 12.6841 16.2941 12.4629 16.1444 12.2721C16.0252 12.1202 15.8677 11.9942 15.5526 11.7421L13.2215 9.8773C12.9062 9.62501 12.7485 9.49886 12.5748 9.45434C12.4218 9.4151 12.2607 9.42018 12.1104 9.46899C11.94 9.52437 11.7905 9.6602 11.4917 9.93187Z"
      stroke="#475467"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
